"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Separator = exports.Label = exports.Group = exports.Item = exports.Content = exports.Trigger = exports.Root = void 0;
var select_js_1 = require("./select.js");
Object.defineProperty(exports, "Root", { enumerable: true, get: function () { return select_js_1.SelectRoot; } });
var select_js_2 = require("./select.js");
Object.defineProperty(exports, "Trigger", { enumerable: true, get: function () { return select_js_2.SelectTrigger; } });
var select_js_3 = require("./select.js");
Object.defineProperty(exports, "Content", { enumerable: true, get: function () { return select_js_3.SelectContent; } });
var select_js_4 = require("./select.js");
Object.defineProperty(exports, "Item", { enumerable: true, get: function () { return select_js_4.SelectItem; } });
var select_js_5 = require("./select.js");
Object.defineProperty(exports, "Group", { enumerable: true, get: function () { return select_js_5.SelectGroup; } });
var select_js_6 = require("./select.js");
Object.defineProperty(exports, "Label", { enumerable: true, get: function () { return select_js_6.SelectLabel; } });
var select_js_7 = require("./select.js");
Object.defineProperty(exports, "Separator", { enumerable: true, get: function () { return select_js_7.SelectSeparator; } });
//# sourceMappingURL=select.parts.js.map